<h4 class="title">License Create</h4>

<div class="card-box">
    <div class="row" style="padding: 0px 0px 23px 10px;">
        <div class="col-md-4 auto">
            <h5 class="form-lable">Client Name:</h5>
            <p-dropdown [options]="types" [(ngModel)]="cli_type" placeholder="Select" [filter]="true" optionLabel="y" [showClear]="true"></p-dropdown>
           
        </div>
        <div class="col-md-4">
            <h5 class="form-lable">Number of License:</h5>
            <input type="text" pInputText [(ngModel)]="License" placeholder="Number of License">
        </div>
        <div class="col-md-4">
            <h5 class="form-lable">Admin user details:</h5>
            <p-dropdown [options]="adminlist" [(ngModel)]="admin" placeholder="Select" optionLabel="y" [showClear]="true" (ngModelChange)="adduser()"></p-dropdown>
           
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <h5 class="form-lable">Create Admin user details:</h5>
                </div>
                <div class="col-md-3">
                    <input type="text" pInputText [(ngModel)]="con_name" placeholder="Name" [disabled]="admin != undefined">
                </div>
                <div class="col-md-3">
                    <input type="text" pInputText [(ngModel)]="email" placeholder="Email" [disabled]="admin != undefined">
                </div>
                <div class="col-md-2">
                    <input type="text" pInputText [(ngModel)]="con_pone" placeholder="Phone" [disabled]="admin != undefined">
                </div>
                <div class="col-md-3">
                    <input type="text" pInputText [(ngModel)]="Password" placeholder="Password" >
                </div>
                <div class="col-md-1 text-right">
                    <i class="fa fa-plus add-icon" (click)="addcontact()" aria-hidden="true" pTooltip="Add"></i>
                </div>
               
                
            </div>
            <table *ngIf="contactarray.length > 0 " class="spec-table">
                <thead>
                <th>S.No</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Password</th>
                <th>Remove</th>
            </thead>
            <tbody>
                <tr *ngFor="let arr of contactarray ; let i= index;">
                    <td>{{i+1}}</td>
                    <td>{{arr.con_name}}</td>
                    <td>{{arr.email}}</td>
                    <td>{{arr.con_pone}}</td>
                    <td>{{arr.password}}</td>
                    <td><i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete" (click)="remove_contact(i)"></i></td>
                </tr>
            </tbody>
            </table>
        </div>
        <!-- <div class="col-md-6">
            <h5 class="form-lable">Client Address:</h5>
            <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="address"></textarea>
        </div> -->
        <!-- <div class="col-md-12">
            <div class="row">
                <div class="col-md-3">
                    <h5 class="form-lable">Profile Image:</h5>
                    <input type="file">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Govt ID proof:</h5>
                    <input type="file">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Photo ID proof:</h5>
                    <input type="file">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Certificate:</h5>
                    <input type="file">
                </div>
                <div class="col-md-12 mt-20">
                    <h5 class="form-lable">Other images:</h5>
                    <p-fileUpload name="demo[]" url="./upload.php" (onUpload)="onUpload($event)" multiple="multiple"
                        accept="image/*" maxFileSize="1000000">
                        <ng-template pTemplate="content">
                            <ul *ngIf="uploadedFiles.length">
                                <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                            </ul>
                        </ng-template>
                    </p-fileUpload>
                </div>
            </div>
        </div> -->

        <div class="col-md-12 mt-20">
            <button type="button" class="btn btn-primary">Create</button>
            <button type="button" class="btn btn-primary btn-bg-blue" (click)="cancel()">Cancel</button>
        </div>

    </div>
</div>